import Skeleton from "react-loading-skeleton";
import useIsMobile from "../../customHooks/useIsMobile";
import "./Tips.css";

const Tips = ({ cards = [], title, isPending }) => {
  const isMobile = useIsMobile();

  const getCardWidth = (id) => {
    const widths = {
      1: "100%",
      2: "100%",
      3: "100%",
      4: "100%",
      5: "100%",
      6: "100%",
      7: "100%",
      8: "100%",
    };
    return widths[id] || "100%";
  };

  const getCardHeight = (id) => {
    const heights = {
      1: "239px",
      2: "174px",
      3: "159px",
      4: "254px",
      5: "418px",
      6: "281px",
      7: "281px",
      8: "281px",
    };
    const responsiveHeights = {
      1: "77px",
      2: "56px",
      3: "50px",
      4: "82px",
      5: "141px",
      6: "90px",
      7: "90px",
      8: "90px",
    };
    return isMobile ? responsiveHeights[id] : heights[id] || "200px";
  };

  const renderCard = (card) => (
    <div
      className="tip-card"
      key={card.id}
      style={{
        overflow: "hidden",
        height: getCardHeight(card.id),
        width: getCardWidth(card.id),
      }}
    >
      {isPending ? (
        <Skeleton height={getCardHeight(card.id)} width="100%" />
      ) : (
        <>
          <div className="card-image-wrapper">
            <img src={card.image} alt={card.title} className="card-image" />
            {card.hasPlayButton && <div className="play-button">▶</div>}
          </div>
          <p className="card-title">{card.title}</p>
        </>
      )}
    </div>
  );

  return (
    <div className="Tips">
      <h2 className="text-center mb-4">{title}</h2>

      <div className="cards-gridx row g-1 g-md-4">
        <div className="col-3">
          <div className="row gap-1 gap-md-4">
            {cards[0] && <div className="col-12">{renderCard(cards[0])}</div>}
            {cards[1] && <div className="col-12">{renderCard(cards[1])}</div>}
          </div>
        </div>

        <div className="col-4">
          <div className="row gap-1 gap-md-4">
            {cards[2] && <div className="col-12">{renderCard(cards[2])}</div>}
            {cards[3] && <div className="col-12">{renderCard(cards[3])}</div>}
          </div>
        </div>

        <div className="col-5">
          <div className="row">
            {cards[4] && <div className="col-12">{renderCard(cards[4])}</div>}
          </div>
        </div>

        <div className="col-12">
          <div className="row g-1 g-md-4">
            {cards[5] && <div className="col-3">{renderCard(cards[5])}</div>}
            {cards[6] && <div className="col-4">{renderCard(cards[6])}</div>}
            {cards[7] && <div className="col-5">{renderCard(cards[7])}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tips;
